import { render, staticRenderFns } from "./step-verificaDatos.vue?vue&type=template&id=b83b790a&"
import script from "./step-verificaDatos.vue?vue&type=script&lang=js&"
export * from "./step-verificaDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports